import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { UserDetail } from '@/types/settings';

/**
 * Fetch a single user by id via `GET /users/:id`. The detail page must not
 * source the user from the paginated `useUsers` list — that only loads the
 * first page, so direct links to a user beyond it would render "not found".
 */
export function useUser(id: string) {
  return useApiQuery<UserDetail>({
    queryKey: settingsKeys.userDetail(id),
    queryFn: () => apiGet<UserDetail>(operationsClient, settingsEndpoints.userDetail(id)),
    enabled: Boolean(id),
    showErrorToast: false,
  });
}
